module.exports = __webpack_public_path__ + "img/406.4b4556ac.jpg";